module.exports = __webpack_public_path__ + "img/lw-exp-2.a35bfa42.jpg";